import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,} from '@angular/core';
import {EventService} from '../../shared/services/event.service';
import {IObject, IStage} from '../../shared/models/models';
import {UserInfo} from '../header/header.component';
import {ServerService} from '../../shared/services/server.service';

import {ModalWindowComponent} from '../../std-components/modal-window/modal-window.component';
import {SendData} from '../object/object-financing/object-financing.component';
import {ToastrService} from 'ngx-toastr';
import moment from "moment";
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NumberWithSpacesPipe} from '../../shared/pipes/number-with-spaces.pipe';

interface IData {
  month: string;
  days: IDay[];
}

interface IDay {
  day: any;
  active?: boolean;
  popup?: boolean;
}

export interface IBeAf {
  be: any;
  af: any;
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  imports: [CommonModule, FormsModule, NumberWithSpacesPipe],
  standalone: true
})
export class CalendarComponent implements OnInit, OnChanges {
  year: number;
  months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];
  data: IData[] = [];

  @Input()
  stage: IStage = null;
  @Input()
  use: string = 'default';
  @Input() openedCalendar: string;

  @Input()
  object: IObject = null;

  @Input()
  inputDate: number = null;
  @Output()
  outputDate = new EventEmitter<number>();

  @Input()
  inputStartDate: number = null;
  @Output()
  outputStartDate = new EventEmitter<number>();

  @Input()
  inputEndDate: number = null;
  @Output()
  outputEndDate = new EventEmitter<number>();

  @Input()
  inputCompleteDate = null;
  @Output()
  outputCompleteDate = new EventEmitter<any>();

  @Input()
  inputCompleteDates: IBeAf = null;
  @Output()
  outputCompleteDates = new EventEmitter<IBeAf>();

  @Input()
  paramsID: number;

  @Input()
  calendarType?: string = 'pickDate'; //pickPeriod //setValueInDate // setValuesInDate

  @Input() acceptBtnFlag: boolean = true;
  counter: number = 0;

  @Input() financingEndDate: number;

  @Input() financingObject: boolean;

  pickDate = {
    day: null,
    month: null,
    year: null,
  };

  tempDates: null;

  @Input()
  buildingId: number = null;

  @Input()
  years = [
    {year: (new Date().getFullYear()) - 1, class: ''},
    {year: (new Date().getFullYear()), class: ''},
    {year: (new Date().getFullYear()) + 1, class: ''},
    /*{ year: 2016, class: '' },
    { year: 2017, class: '' },
    { year: 2018, class: '' },
    { year: 2019, class: '' },*/
  ];
  @Input()
  valueDimension: string = '%';
  @Input()
  editedDate: number = null;

  @Input()
  obj: SendData[] = [];
  @Input()
  livingComID: number;

  @Input() duration;

  @Input() constructionStartDate = null;
  @Input() constructionEndDate = null;

  public editValue: number;

  public editSmr: number;
  public editTeh: number;
  public editAut: number;
  public editDop: number;

  editDate: number = null;
  doubleEditDate: number = null;

  public user: UserInfo = null;
  mioReadOnlyUserFlag: boolean = false;

  years1 = [];
  centerYear: number;
  date: Date;
  setEditValues: boolean = false;

  constructor(
    private eventService: EventService,
    private server: ServerService,
    private modalWindow: ModalWindowComponent,
    public toastr: ToastrService
  ) {}

  ngOnInit() {
    let user = localStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
    }
    this.getUser();
    this.date = new Date();
    this.centerYear = this.date.getFullYear();
    this.years1 = [this.centerYear - 1, this.centerYear, this.centerYear + 1];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getCalendar();
  }

  fileToUpload: any;
  //
  fileType: any;
  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fileType = this.fileToUpload.type.substr(
      this.fileToUpload.type.indexOf('/') + 1
    );
  }

  selectPrev() {
    this.years1.splice(2, 1);
    this.years1.unshift(this.years1[0] - 1);
  }

  selectNext() {
    this.years1.splice(0, 1);
    this.years1.push(this.years1[1] + 1);
  }

  getCalendar() {
    if (this.calendarType == 'pickPeriod') {
      if (this.inputStartDate && this.inputEndDate) {
        this.counter = 2;
      }
    }
    if (this.calendarType == 'setValueInDate' && this.use == 'percent') {
      this.inputStartDate = this.stage.start_date;
      this.inputEndDate = this.stage.end_date;
    }
    if (this.openedCalendar !== 'edit') {
      let date = new Date(this.inputStartDate);
      let endDate = date.setMonth(date.getMonth() + this.duration);
      this.inputEndDate = endDate;
    }
    if (this.inputStartDate && this.inputEndDate) {
      let firstDate = parseInt(moment(this.inputStartDate).format('YYYY'));
      let secondDate = parseInt(moment(this.inputEndDate).format('YYYY'));
      // if (firstDate != secondDate) {
      //   // this.years.find(r => r.year === firstDate).class = "yellow";
      //   // this.years.find(r => r.year === secondDate).class = "blue";
      // }
      if (firstDate == secondDate) {
        console.log(this.years, firstDate, secondDate, '----------')
        this.years.map((r) => {
          r.class = '';
        });
        this.years.find((r) => r.year === firstDate).class = 'yellow';
      }
      this.year = firstDate;
      this.generateCalendar(firstDate);
    } else if (this.editedDate) {
      let edit_date = new Date(this.editedDate);
      let date = edit_date.getDate();
      let month = edit_date.getMonth();
      this.year = edit_date.getFullYear();
      let weekDay = this.getWeekDay(0, month, this.year);
      this.generateCalendar(this.year);
      this.setDate(date, month, month, date + weekDay - 1);
    } else {
      this.years.map((r) => {
        r.class = '';
      });
      this.year = new Date().getFullYear();
      this.generateCalendar(this.year);
    }
  }

  getUser() {
    let user = localStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
      if (user) {
        this.user = JSON.parse(user);
        if (this.user.roles.some((e) => e === 'MioReadOnlyUser')) {
          this.mioReadOnlyUserFlag = true;
        }
      }
    }
  }

  acceptCalendar() {
    if (this.calendarType == 'pickDate') {
      let timestamp = this.getTimestamp(
        this.pickDate.day,
        this.pickDate.month,
        this.pickDate.year
      );
      if (timestamp < 0) return;
      this.outputDate.emit(timestamp);
    }

    if (this.calendarType == 'pickPeriod') {
      this.outputStartDate.emit(this.inputStartDate);
      this.outputEndDate.emit(this.inputEndDate);
    }

    if (this.calendarType == 'setValueInDate') {
      this.outputCompleteDate.emit(this.inputCompleteDate);
    }

    if (this.calendarType == 'setValuesInDate') {
      this.outputCompleteDates.emit(this.inputCompleteDates);
    }

    if (this.use == 'financing') {
      this.updatetable();
    }
  }

  updatetable() {
    if (this.obj.length > 0) {
      this.server.setInvestAmount(this.obj).then(
        () => {
          this.toastr.success('Изменения сохранены!', 'Успешно!');
          this.eventService.invest.emit();
        },
        (err: any) => {
          if (err.status == 500 || err.status == 0) {
            this.toastr.error(
              'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!',
              'Ваши данные не сохранены!'
            );
          }
        }
      );
    }
  }

  decline() {
    this.modalWindow.closeModalWindow();
  }

  setDate(day: number, month: number, monthIndex: number, dayIndex: number) {
    if (this.calendarType == 'pickDate') {
      this.pickDate.year = this.year;
      this.pickDate.month = month;
      this.pickDate.day = day;
      this.inputDate = this.getTimestamp(day, month, this.year);
    }

    if (this.calendarType == 'pickPeriod') {
      if (this.counter == 2) {
        this.inputStartDate = null;
        this.inputEndDate = null;
        this.counter = 0;
      }

      if (!this.inputStartDate) {
        this.inputStartDate = this.getTimestamp(day, month, this.year);
      } else {
        let endDate = this.getTimestamp(day, month, this.year);
        if (this.inputStartDate > endDate) {
          this.inputEndDate = this.inputStartDate;
          this.inputStartDate = this.getTimestamp(day, month, this.year);
        } else {
          this.inputEndDate = this.getTimestamp(day, month, this.year);
        }
      }
      this.counter++;
    }

    if (this.calendarType == 'setValueInDate') {
      this.data.map((r) => {
        r.days.map((re) => {
          re.popup = false;
        });
      });

      let timestamp = this.getTimestamp(day, month, this.year);
      if (this.inputCompleteDate[timestamp]) {
        this.editValue = this.inputCompleteDate[timestamp];
        if (this.financingObject) {
          if (!this.setEditValues) {
            this.editSmr = this.inputCompleteDate[timestamp][0];
            this.editTeh = this.inputCompleteDate[timestamp][1];
            this.editAut = this.inputCompleteDate[timestamp][2];
            this.editDop = this.inputCompleteDate[timestamp][3];
            this.setEditValues = true;
          }
        }
      } else {
        this.editValue = null;
      }

      this.data[monthIndex].days[dayIndex].popup =
        !this.data[monthIndex].days[dayIndex].popup;

      this.editDate = this.getTimestamp(day, month, this.year);
    }

    if (this.calendarType == 'setValuesInDate') {
      this.doubleEditDate = this.getTimestamp(day, month, this.year);
    }
    if (this.use === 'financing-flat') {
      this.inputCompleteDate = {};
      this.inputCompleteDate[this.getTimestamp(day, month, this.year)] =
        this.editValue;
    }
  }

  hoverDate: number = null;
  mouseOverDay(day: number, monthIndex: number) {
    this.hoverDate = this.getTimestamp(day, monthIndex, this.year);
  }

  editCheck(day: number, month: number) {
    let timestamp = this.getTimestamp(day, month, this.year);
    if (this.inputCompleteDate[timestamp]) {
      this.editValue = this.inputCompleteDate[timestamp];
      if (this.financingObject) {
        this.editSmr = this.inputCompleteDate[timestamp][0];
        this.editTeh = this.inputCompleteDate[timestamp][1];
        this.editAut = this.inputCompleteDate[timestamp][2];
        this.editDop = this.inputCompleteDate[timestamp][3];
      }

      //   //this.tempDates[timestamp] = this.inputCompleteDate[timestamp];
    } else {
      this.editValue = null;
    }
    return this.editDate === timestamp;
  }

  acceptEditCheck(day: number, month: number, dayIndex: number) {
    if (this.financingObject) {
      if (this.use === 'financing-flat') {
        this.inputCompleteDate = {};
      }
      // this.inputCompleteDate[
      //   this.getTimestamp(day, month, this.year)
      // ] = this.editSmr;

      // this.inputCompleteDate[
      //   this.getTimestamp(day, month, this.year)
      // ] = this.editTeh;

      // this.inputCompleteDate[
      //   this.getTimestamp(day, month, this.year)
      // ] = this.editAut;

      let summ =
        (this.editSmr ? this.editSmr : 0) +
        (this.editTeh ? this.editTeh : 0) +
        (this.editAut ? this.editAut : 0) +
        (this.editDop ? this.editDop : 0);

      this.inputCompleteDate[this.getTimestamp(day, month, this.year)] = [
        this.editSmr ? this.editSmr : 0,
        this.editTeh ? this.editTeh : 0,
        this.editAut ? this.editAut : 0,
        this.editDop ? this.editDop : 0,
      ];

      this.editSmr = null;
      this.editTeh = null;
      this.editAut = null;
      this.editDop = null;
      // this.editValue = null;
      this.editDate = null;
      this.data[month].days[dayIndex].popup = false;
    } else {
      // TODO: Make Accept By Another Variable
      if (this.use === 'financing-flat') {
        this.inputCompleteDate = {};
      }
      this.inputCompleteDate[this.getTimestamp(day, month, this.year)] =
        this.editValue;
      this.editValue = null;
      this.editDate = null;
      this.data[month].days[dayIndex].popup = false;
      // if(this.use === 'financing'){
      //   if (this.calendarType == 'pickDate') {
      //     let timestamp = this.getTimestamp(this.pickDate.day, this.pickDate.month, this.pickDate.year);
      //     this.outputDate.emit(timestamp);
      //   }

      //   if (this.calendarType == 'pickPeriod') {
      //     this.outputStartDate.emit(this.inputStartDate);
      //     this.outputEndDate.emit(this.inputEndDate);
      //   }

      //   if (this.calendarType == 'setValueInDate') {
      //     this.outputCompleteDate.emit(this.inputCompleteDate);
      //   }

      //   if (this.calendarType == 'setValuesInDate') {
      //     this.outputCompleteDates.emit(this.inputCompleteDates);
      //   }
      // }
    }
  }

  cancelEditCheck(monthIndex: number, dayIndex: number) {
    this.data[monthIndex].days[dayIndex].popup = false;
    this.editDate = null;
    this.editValue = null;
    this.editSmr = null;
    this.editTeh = null;
    this.editAut = null;
    this.editDop = null;
  }

  removeEditCheck(
    day: number,
    month: number,
    monthIndex: number,
    dayIndex: number
  ) {
    let timestamp = this.getTimestamp(day, month, this.year);

    if (this.use === 'financing' && this.acceptBtnFlag) {
      this.inputCompleteDate[timestamp] = null;
    }

    if (this.use === 'financing' && !this.acceptBtnFlag) {
      if (!confirm('Вы уверены, что хотите удалить стоимость затрат?'))
        return false;
      this.inputCompleteDate[timestamp] = null;
      this.outputCompleteDate.emit(this.inputCompleteDate);
    }

    if (this.use === 'financing-flat') {
      this.inputCompleteDate = {};
    }

    if (this.use === 'percent') {
      this.server
        .deleteFactValue(this.buildingId, this.stage.number, timestamp)
        .then(
          (res) => {
            this.toastr.success('Изменения сохранены!', 'Успешно!');
            delete this.inputCompleteDate[timestamp];
            this.editDate = null;
            this.editValue = null;
            this.editSmr = null;
            this.editTeh = null;
            this.editAut = null;
            this.editDop = null;
          },
          (err: any) => {
            if (err.status == 500 || err.status == 0) {
              this.toastr.error(
                'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!',
                'Ваши данные не сохранены!'
              );
            }
          }
        );
    }

    this.data[monthIndex].days[dayIndex].popup = false;
  }

  doubleEditCheck(day: number, month: number) {
    let timestamp = this.getTimestamp(day, month, this.year);
    return this.doubleEditDate == timestamp;
  }

  saveCompleteValue(event) {
    if (event.keyCode == 13) {
      this.editDate = null;
      this.doubleEditDate = null;
    }
  }

  getTimestamp(day: number, month: number, year: number) {
    return new Date(year, month, day).getTime();
  }

  setYear(year: number) {
    this.year = year;
    this.generateCalendar(year);
  }

  generateCalendar(year: number) {
    this.data = [];
    let date = new Date();
    this.months.forEach((e, index) => {
      let days = this.getDaysInMonth(index, year);
      let array = [];
      let weekDay = this.getWeekDay(0, index, year);
      for (let i = 1; i <= weekDay; i++) {
        array.push({
          day: '',
        });
      }
      for (let i = 1; i <= days; i++) {
        array.push({
          day: i,
          active:
            index == date.getMonth() &&
            i == date.getDate() &&
            date.getFullYear() == this.year,
          popup: false,
        });
      }
      this.data.push({
        month: e,
        days: array,
      });
    });
  }

  getDateValue(day: number, month: number) {
    if (this.calendarType == 'setValueInDate') {
      let timestamp = this.getTimestamp(day, month, this.year);
      if (this.inputCompleteDate.hasOwnProperty(timestamp)) {
        return this.inputCompleteDate[timestamp] + this.valueDimension;
      }
    }
  }

  getDayClasses(day: number, month: number, dayIndex: number, active: boolean) {
    let classes = [];
    let now = this.getTimestamp(day, month, this.year);

    if (!day) {
      return 'empty';
    }

    // if (now == this.inputDate || now == this.inputStartDate || now == this.inputEndDate) {
    //   return 'select';
    // }

    if (this.calendarType == 'pickPeriod') {
      if (
        now == this.inputDate ||
        now == this.inputStartDate ||
        now == this.inputEndDate
      ) {
        return 'select';
      }
    }

    if (now == this.inputDate) {
      return 'select';
    }

    if (active) {
      return 'active';
    }

    if (this.calendarType == 'setValuesInDate') {
      if (
        this.inputCompleteDates &&
        this.inputCompleteDates.be &&
        this.inputCompleteDates.be.hasOwnProperty(now)
      ) {
        return 'hasData';
      }
    }

    if (this.calendarType == 'setValueInDate') {
      // let firstDate = parseInt(moment(this.inputStartDate).format("YYYY"));
      // this.year = firstDate;
      // this.generateCalendar(firstDate);
      if (this.stage) {
        if (
          this.inputCompleteDate &&
          this.inputCompleteDate.hasOwnProperty(now)
        ) {
          return 'hasData';
        } else if (now == this.stage.start_date || now == this.stage.end_date) {
          return 'select';
        } else if (now > this.stage.start_date && now < this.stage.end_date) {
          return 'period';
        }
      }
      if (
        this.inputCompleteDate &&
        this.inputCompleteDate.hasOwnProperty(now)
      ) {
        return 'hasData';
      }
      if (this.use == 'financing') {
        let date = new Date(this.inputStartDate);
        let endDate = date.setMonth(date.getMonth() + this.duration);

        if (now > this.inputStartDate && now < endDate) {
          return 'period';
        }
        if (
          now == this.inputDate ||
          now == this.inputStartDate ||
          now == endDate
        ) {
          return 'select';
        }
      }
    }

    if (this.calendarType == 'pickPeriod') {
      if (now > this.inputStartDate && now < this.inputEndDate) {
        return 'period';
      }
    }

    return classes.join(' ');
  }

  getDaysInMonth(month: number, year: number) {
    return new Date(year, month + 1, 0).getDate();
  }

  getWeekDay(day: number, month: number, year: number) {
    let date = new Date(year, month, day);
    return date.getDay();
  }

  getTopValue(month: number, year: number) {
    if (this.use == 'percent') {
      let total = 0;
      let c = 0;
      for (let i = 1; i <= this.daysInMonth(month, year); i++) {
        let timestamp = this.getTimestamp(i, month, this.year);
        if (this.inputCompleteDate.hasOwnProperty(timestamp)) {
          total = total + this.inputCompleteDate[timestamp];
          c++;
        }
      }
      return c != 0 ? Math.round(total / c) + '%' : '-';
    } else if (this.use == 'financing' || this.use === 'financing-flat') {
      let total = 0;
      for (let i = 1; i <= this.daysInMonth(month, year); i++) {
        let timestamp = this.getTimestamp(i, month, this.year);
        if (this.inputCompleteDate.hasOwnProperty(timestamp)) {
          total =
            total +
            this.inputCompleteDate[timestamp][0] +
            this.inputCompleteDate[timestamp][1] +
            this.inputCompleteDate[timestamp][2] +
            this.inputCompleteDate[timestamp][3];
        }
      }
      return total != 0 ? total : '-';
    } else if (this.use == 'realization') {
      let be = 0;
      let af = 0;
      if (this.inputCompleteDates.be && this.inputCompleteDates.af) {
        for (let i = 1; i <= this.daysInMonth(month, year); i++) {
          let timestamp = this.getTimestamp(i, month, this.year);
          if (this.inputCompleteDates.be.hasOwnProperty(timestamp)) {
            be = be + this.inputCompleteDates.be[timestamp];
          }
          if (this.inputCompleteDates.af.hasOwnProperty(timestamp)) {
            af = af + this.inputCompleteDates.af[timestamp];
          }
        }
      }
      return [be, af];
    }
  }

  getTotalValue() {
    if (this.use == 'financing' || this.use === 'financing-flat') {
      let total = 0;
      for (let m = 0; m < 12; m++) {
        for (let i = 1; i <= this.daysInMonth(m, this.year); i++) {
          let timestamp = this.getTimestamp(i, m, this.year);
          if (this.inputCompleteDate.hasOwnProperty(timestamp)) {
            total =
              total +
              this.inputCompleteDate[timestamp][0] +
              this.inputCompleteDate[timestamp][1] +
              this.inputCompleteDate[timestamp][2] +
              this.inputCompleteDate[timestamp][3];
          }
        }
      }
      return total != 0 ? total : 0;
    }

    if (this.use == 'realization') {
      let be = 0;
      let af = 0;
      if (this.inputCompleteDates.be && this.inputCompleteDates.af) {
        for (let m = 0; m < 12; m++) {
          for (let i = 1; i <= this.daysInMonth(m, this.year); i++) {
            let timestamp = this.getTimestamp(i, m, this.year);
            if (this.inputCompleteDates.be.hasOwnProperty(timestamp)) {
              be = be + this.inputCompleteDates.be[timestamp];
            }
            if (this.inputCompleteDates.af.hasOwnProperty(timestamp)) {
              af = af + this.inputCompleteDates.af[timestamp];
            }
          }
        }
      }
      return [be, af];
    }
  }

  daysInMonth(month: number, year: number) {
    return new Date(year, month, 0).getDate();
  }
}
